module.exports = __webpack_public_path__ + "static/media/ic-video-camera-disabled.abba4536.png";